import { Box, rem } from '@mantine/core'
import { modals } from '@mantine/modals'
import { merge } from 'lodash-es'
import type { ReactNode } from 'react'
import confirmClasses from './Confirm.module.css'

type OpenConfirmModal = Parameters<typeof modals.openConfirmModal>[0]

export function showConfirm(
	title: ReactNode,
	content?: ReactNode,
	options?: Omit<OpenConfirmModal, 'title' | 'children'>
) {
	return new Promise<void>((resolve, reject) => {
		const props = merge<Partial<OpenConfirmModal>, OpenConfirmModal | undefined>(
			{
				groupProps: {
					gap: 10,
					justify: 'center',
				},
				styles: {
					body: {
						color: 'var(--tint-primary)',
					},
					content: {
						backgroundColor: 'var(--bg-body-1)',
					},
					header: {
						backgroundColor: 'var(--bg-body-1)',
					},
					title: {
						color: 'var(--tint-primary)',
					},
				},
				cancelProps: {
					children: '再想想',
					c: 'var(--tint-primary)',
					bd: '1px solid var(--tint-separator)',
					h: 44,
					miw: 130,
					p: '10px 21px',
					radius: 100,
					fz: 16,
					lh: rem(24),
					fw: 400,
					bg: 'unset',
				},
				confirmProps: {
					children: '确定',
					c: 'var(--solid-gray-4)',
					color: 'var(--bg-jike-yellow)',
					h: 44,
					miw: 130,
					p: '10px 21px',
					radius: 100,
					fz: 16,
					lh: rem(24),
					fw: 400,
				},
			},
			options
		)
		modals.openConfirmModal({
			title,
			children: <Box className={confirmClasses.body}>{content}</Box>,
			withCloseButton: false,
			...props,
			onCancel: () => {
				options?.onCancel?.()
				reject()
			},
			onConfirm: () => {
				options?.onConfirm?.()
				resolve()
			},
		})
	})
}

export function showAlert(
	title: ReactNode,
	content?: ReactNode,
	options?: Omit<OpenConfirmModal, 'title' | 'children'>
) {
	return showConfirm(
		title,
		content,
		merge<Partial<OpenConfirmModal>, OpenConfirmModal | undefined>(
			{
				cancelProps: {
					style: {
						display: 'none',
					},
				},
			},
			options
		)
	)
}
